export default __webpack_public_path__ + "static/media/seamlessTools303030GreyPlain.d2c4af9c.svg";